import React from 'react';
import PropTypes from 'prop-types';
import { normalizeStatusClass } from './sectionShared';

const RiskIdentityCell = ({ row }) => (
  <td className="td-cell">
    <div className="risk-id-cell">
      <div className="risk-id-text">
        {row.id ? (
          <div className="risk-id">{row.id}</div>
        ) : null}
        <span className={`status-badge ${normalizeStatusClass(row.status)}`}>
          {row.status || ''}
        </span>
      </div>
    </div>
  </td>
);

const IssueIdentityCell = ({ row }) => (
  <td className="td-cell">
    <div className="risk-id-cell">
      <div className="risk-id-text">
        {row.id ? (
          <div className="risk-id">{row.id}</div>
        ) : null}
        <span className={`status-badge ${normalizeStatusClass(row.status)}`}>
          {row.status || ''}
        </span>
      </div>
    </div>
  </td>
);

const DescriptionCell = ({ value }) => {
  const description = value || '';

  return (
    <td className="td-cell td-description">
      <span
        className="single-line-description"
        title={description}
        aria-label={description}
        tabIndex={description ? 0 : undefined}
      >
        {description}
        {description ? (
          <span className="description-tooltip" role="tooltip">
            {description}
          </span>
        ) : null}
      </span>
    </td>
  );
};

const ImpactCell = ({ value, className = '' }) => (
  <td className={`td-cell ${className}`.trim()}>
    {value || ''}
  </td>
);

RiskIdentityCell.propTypes = {
  row: PropTypes.object.isRequired,
};

IssueIdentityCell.propTypes = {
  row: PropTypes.object.isRequired,
};

DescriptionCell.propTypes = {
  value: PropTypes.string,
};

ImpactCell.propTypes = {
  value: PropTypes.string,
  className: PropTypes.string,
};

export {
  DescriptionCell,
  ImpactCell,
  IssueIdentityCell,
  RiskIdentityCell,
};
